import imagesLoaded from 'imagesloaded'
import getNodeDimensions from 'get-node-dimensions'

class Accordion {
    constructor (theme, elem) {
        this._name = this.constructor.name
        this._elem = elem
        this._settings = this._elem.dataset.settings ? JSON.parse(this._elem.dataset.settings) : {}
        this._items = this._elem.querySelectorAll('[data-accordion-item]').length ? this._elem.querySelectorAll('[data-accordion-item]') : [this._elem]
        this._transitioning = false
    }

    onInit () {
        if (this._settings.showAbove && window.innerWidth <= this._settings.showAbove) {
            return false
        }

        if (this._settings.showBelow && window.innerWidth >= this._settings.showBelow) {
            return false
        }

        for (let accordionItem of this._items) {
            let header = accordionItem.querySelector('[data-accordion-header]')

            if (accordionItem.hasAttribute('data-close-mobile') && window.innerWidth <= 768) {
                accordionItem.classList.remove('initial')
                this.closeAccordion(accordionItem)
            }

            header.addEventListener('click', (e) => {
                e.preventDefault()
                console.log(this._transitioning)
                if (this._transitioning) return false
                this._transitioning = true
                for (let otherAccordion of this._items) {
                    if (accordionItem.dataset.accordionItem && (accordionItem.dataset.accordionItem !== otherAccordion.dataset.accordionItem)) {
                        continue
                    }
                    if (otherAccordion === accordionItem) continue
                    this.closeAccordion(otherAccordion)
                }
                this.toggleAccordion(accordionItem)
            })
        }

        imagesLoaded(this._elem, () => {
            this.updateAccordions()
        })
    }

    updateAccordions () {
        for (let accordionItem of this._items) {
            if (accordionItem.classList.contains('open')) {
                this.openAccordion(accordionItem)
            }
        }
    }

    closeAccordion (accordion) {
        let instance = this
        let content = accordion.querySelector('[data-accordion-content]')
        let dimensions = getNodeDimensions(content)
        content.style.maxHeight = `${dimensions.height}px`
        content.classList.remove('accordion-item--expanded')

        let closeEvent = e => {
            if (e.propertyName === 'max-height') {
                instance._transitioning = false
                content.removeEventListener('transitionend', closeEvent, false)
            }
        }
        content.addEventListener('transitionend', closeEvent, false)
        this.nextFrame(() => {
            content.style.maxHeight = `0px`
            accordion.classList.remove('open')
        })
    }

    openAccordion (accordion) {
        let instance = this
        let content = accordion.querySelector('[data-accordion-content]')
        content.style.maxHeight = 'none'
        let dimensions = getNodeDimensions(content)
        content.style.maxHeight = '0px'
        let openEvent = e => {
            if (e.propertyName === 'max-height') {
                instance._transitioning = false
                content.style.maxHeight = 'none'
                content.classList.add('accordion-item--expanded')
                content.removeEventListener('transitionend', openEvent, false)
            }
        }
        content.addEventListener('transitionend', openEvent, false)
        this.nextFrame(() => {
            content.style.maxHeight = `${dimensions.height}px`
            accordion.classList.add('open')
        })
    }

    toggleAccordion (accordion) {
        if (accordion.classList.contains('open')) {
            this.closeAccordion(accordion)
        } else {
            this.openAccordion(accordion)
        }
    }

    nextFrame (callback) {
        window.requestAnimationFrame(() => {
            window.requestAnimationFrame(callback)
        })
    }
}
export default Accordion



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Accordion.js